import { Link } from 'react-router-dom';

import arrowRight from 'assets/icons/arrowRight.svg';
import { useMemo } from 'react';

export const LibertyCrumbs = ({ e, b, location, styles }) => {
  const pathToGo = useMemo(() => {
    if (e.path.includes('/request-detail/:quote')) {
      return `${e.path}${b[0]}`;
    } else {
      return e.pathToGo(location);
    }
  }, [e, b, location]);

  return (
    <span className={styles.title}>
      <img src={arrowRight} alt="arrow" className={styles.arrow} />
      <Link
        onClick={() => {
          window.location.replace(pathToGo);
        }}
        to={pathToGo}
        style={e.style}
      >
        {e.title}
      </Link>
    </span>
  );
};
